export default __webpack_public_path__ + "static/media/headset12.1d046bb2.jfif";